import CarotekColors from "@carotek/utils/Colors";
import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { columnsStyles } from "@insite/content-library/Widgets/ProductList/ProductListColumns";
import { productCountStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductCount";
import { searchWithinStyles } from "@insite/content-library/Widgets/ProductList/ProductListSearchWithin";
import { GridOffset } from "@insite/mobius/GridContainer";
import Search from "@insite/mobius/Icons/Search";
import { css } from "styled-components";

Object.assign(searchWithinStyles, {
    ...searchWithinStyles,
    wrapper: {
        css: css`
            border: 1px solid ${CarotekColors.grey3};
            border-top: 0;
            border-bottom: 0;
            padding: 4px 15px 18px;
        `,
    },
    titleText: {
        variant: "h6",
        color: "text.main",
        fontFamily: "OpenSansSemiBold",
        size: 14,
        css: css`
            margin-bottom: 3px;
        `,
    },
    searchTextField: {
        iconProps: { src: Search },
        cssOverrides: {
            formField: css`
                width: 100%;
            `,
            formInputWrapper: css`
                [class^="StyledButton"] {
                    height: 32.39px;
                    background-color: ${CarotekColors.blue1};

                    :hover {
                        background-color: ${CarotekColors.grey2};
                    }

                    [class^="IconWrapper"] {
                        top: -2px;

                        svg {
                            stroke: ${CarotekColors.white};
                        }
                    }
                }
            `,
            inputSelect: css`
                width: 82.5%;
                height: 32.39px;
                font-size: 12px;
                font-weight: 400;
                border-color: #ccc;

                &:focus,
                &:focus-within {
                    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.25);
                    border: 1px solid ${CarotekColors.grey7} !important;
                    background-color: ${CarotekColors.white} !important;
                }
            `,
        },
    },
});
